import { createFileRoute } from "@tanstack/react-router"
import { LegalTermsPage } from "@/components/legal-pages"

export const Route = createFileRoute("/terms")({
  component: LegalTermsPage,
})
